import Vue from 'vue';
export default Vue.extend({
    name: 'enableMultiAssetModeConfirmPopupChunk',
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: {
                fields: {
                    policyRead: {
                        value: false
                    }
                }
            }
        };
    },
    computed: {
        faqLink() {
            return `https://${window.location.host}/multi-assets-faq/`;
        }
    }
});
